import { addDoubleQuotes } from '../utils/smartutils';

export function contractListByContractFilter(filter) {
  const formattedFilter = {
    id: filter.contract ? filter.contract.id : 0,
    numberContract: filter.contract ? filter.contract.numberContract : 0,
    initialDate: filter.initialDate,
    finalDate: filter.finalDate,
    status: filter.status,
    responsibleId: filter.responsible ? filter.responsible.id : 0,
    studentId: filter.student ? filter.student.id : 0,
  };

  const query = `{
	contractListByContractFilter(
		filter: ${JSON.stringify(formattedFilter).replace(/"([^(")"]+)":/g, '$1:')}
	) {
		id
		student {
			id
      fullName
      activeOnLoggedPeriod
		}
		responsible1 {
			responsible {
				id
				fullName
			}
		}
		numberContract
		validity
		finalDate
		initialDate
    firstExpirationDate
		finalValidityDate
		status
    netValue,
    contractKey,
    totalContractValue,
		contractType {
			id
			name
		}
	}
}
`;
  return query;
}

export function contractNextNumber() {
  const query = '{contractNextNumber}';
  return query;
}

export function accountList() {
  const query = `{
    accountListByFilter(
      filter: {
        filterByStatus: true
        active: false
        updaterId: 0
        checkingAccount: false
        id: 0
        integrateIfIugu: false
        smartpay: false
        defaultAccount: false
        numberWithdrawals: 0
        extraWithdrawalAmount: 0
      }
    ) {
      id
      name
      filterByStatus
      updaterId
      checkingAccount
      active
      defaultAccount
      integrateIfIugu
      smartpay
      numberWithdrawals 
      extraWithdrawalAmount
      iuguAccountInfo {
        verificationStatus
        interestForDelay
        dailyInterestForDelay
        interestRateForDelay
      }
    }
  }  
`;
  return query;
}

export function discountConfigurationByAccount(account) {
  const query = `{
    discountConfigurationByAccount(accountId: ${account}) {
      id
      daysBeforeExpiration
      discountPercentage
    }
  }
  `;
  return query;
}

export function contractById(id) {
  const query = `{
	contractListByFilter(
		filter: { id: ${id}, initialDate: 0, finalDate: 0, status: "" }
	) {
    id
    toGenerate
		student {
			id
      fullName
      filterByStatus
      updaterId
      active
      legacyId
      dateOfBirth
      activeOnLoggedPeriod
		}
		responsible1 {
			responsible {
				id
        fullName
        email
        cellPhone
        cellPhoneAux
        cpf
        zipCode
        address
        addressNumber
        neighborhood
        email
        filterByStatus
        updaterId
        validateCpfOnSubmit
			}
		}
		responsible2 {
			responsible {
				id
        fullName
        email
        cellPhone
        cellPhoneAux
			}
		}
		numberContract
		validity
		competencyDate
		finalDate
		initialDate
		finalValidityDate
		status
		obs
		sumaryContract
		discount
		amount
		netValue
		contractType {
			id
      name
      filterByStatus
      updaterId
      active
		}
		products {
			id
			product {
				id
        name
        filterByStatus
        updaterId
        active
        value
			}
			category {
				id
        name
        filterByStatus
        updaterId
        active
			}
			paymentFrequency {
				id
        name
        type
        monthlyFrequency
        daylyFrequency
        active
        order
			}
			quantity
			unitaryValue
			amount
			discountPercentage
			discountAmount
      firstDueDate
      numberOfInstallments
      contractId
		}
	}
}
`;
  return query;
}

export function contractListId() {
  const query = `{
  contractListByFilter(
    filter: { id: 0, initialDate: 0, finalDate: 0, status: "" }
  ) {
    value
    label
  }
}`;

  return query;
}

export function contractTypeListByFilter() {
  const query = `{
	contractTypeListByFilter(
		filter: { id: 0, filterByActive: true, active: true }
	) {
		id
    name
    filterByStatus
    updaterId
    active
	}
}
`;
  return query;
}

export function studentListByFilter() {
  const query = `{
    studentListByFilter(
      filter: { id: 0, classes: [], responsibles: [], menus: [], onlyActive: true }
    ) {
      id
      fullName
      filterByStatus
      updaterId
      active
      legacyId
      dateOfBirth
      activeOnLoggedPeriod
    }
  }
`;
  return query;
}

export function responsibleStudentRelationListByFinantialContact(studentId) {
  const query = `{
	responsibleStudentRelationListByFinantialContact(
		filter: { id: 0, filterByActive: false, active: false, studentId: ${studentId} }
	) {
		responsible {
			id
      fullName
      filterByStatus
      updaterId
      cpf
      zipCode
      addressNumber
      neighborhood
		}
	}
}
`;
  return query;
}

export function responsibleFinancialContact() {
  const query = `{
	responsibleStudentRelationListByFinantialContact(
		filter: { id: 0, filterByActive: false, active: false, studentId: 0 }
	) {
		responsible {
			id
      fullName
      filterByStatus
      updaterId
      cpf
      zipCode
      addressNumber
		}
	}
}`;
  return query;
}

export function productListByFilter() {
  const query = `{
	productListByFilter(
		filter: { id: 0, filterByStatus: true, active: true, updaterId: 0, value: 0 }
	) {
		id
		name
    value
    filterByStatus
    updaterId
    active
    category {
      id
      name
      filterByStatus
      updaterId
      active
    }
	}
}
`;
  return query;
}

export function paymentFrequencyListByFilter() {
  const query = `{paymentFrequencyListByFilter(filter:{filterByActive:true, active:true})
  {
    id
    name
    type
    monthlyFrequency
    daylyFrequency
    active
    order
  }
}
`;
  return query;
}

export function contractSave(values) {
  const discount = values.products.reduce(
    (total, item) => total + item.discountAmount,
    0
  );
  const amount = values.products.reduce(
    (total, item) => total + item.amount,
    0
  );
  const products = values.products.map((item) => ({
    id: item.id || 0,
    product: {
      id: item.product.id,
      name: item.product.name,
      filterByStatus: item.product.filterByStatus,
      updaterId: item.product.updaterId,
      active: item.product.active,
      value: item.product.value,
    },
    category: {
      id: item.category.id,
      name: item.category.name,
      filterByStatus: item.category.filterByStatus,
      updaterId: item.category.updaterId,
      active: item.category.active,
    },
    paymentFrequency: {
      id: item.paymentFrequency.id,
      name: item.paymentFrequency.name,
      type: item.paymentFrequency.type,
      monthlyFrequency: item.paymentFrequency.monthlyFrequency,
      daylyFrequency: item.paymentFrequency.daylyFrequency,
      active: item.paymentFrequency.active,
      order: item.paymentFrequency.order,
    },
    quantity: item.quantity,
    unitaryValue: item.unitaryValue,
    amount: item.amount,
    discountPercentage: item.discountPercentage,
    discountAmount: item.discountAmount,
    firstDueDate: item.firstDueDate,
    numberOfInstallments: parseInt(item.numberOfInstallments, 10),
    contractId: 0,
  }));
  const mutation = `mutation {
    contractSave(
      contract: {
        id: ${values.id || 0},
        toGenerate: ${values.toGenerate}
        totalContractValue: ${0}
        student: {
          id: ${values.student.id}
          fullName: "${values.student.fullName}"
          filterByStatus: ${values.student.filterByStatus}
          updaterId: ${values.student.updaterId}
          active: ${values.student.active}
          legacyId: ${values.student.legacyId}
          dateOfBirth: ${values.student.dateOfBirth}
          activeOnLoggedPeriod: false
        }
        responsible1: {
          responsible: {
            id: ${values.responsible1.responsible.id}
            fullName: "${values.responsible1.responsible.fullName}"
            filterByStatus: false
            updaterId: 0
            validateCpfOnSubmit: false
            chatUserId: ${
              values.responsible1.responsible.chatUserId
                ? values.responsible1.responsible.chatUserId
                : 0
            }
          }
          id: 0
          accessStudentData: false
          emergencyContact: false
          financialContact: false
          takeStudent: false
        }
        responsible2: ${
          values.responsible2
            ? `{
            responsible: {
              id: ${values.responsible2.responsible.id}
              fullName: "${values.responsible2.responsible.fullName}"
              filterByStatus: false
              updaterId: 0
              validateCpfOnSubmit: false
              chatUserId: ${
                values.responsible2.responsible.chatUserId
                  ? values.responsible2.responsible.chatUserId
                  : 0
              }
            }
            id: 0
            accessStudentData: false
            emergencyContact: false
            financialContact: false
            takeStudent: false
          }`
            : null
        }
        numberContract: "${values.numberContract}"
        validity: ${parseInt(values.validity, 0)}
        competencyDate: ${values.competencyDate.getTime()}
        finalDate: ${values.finalDate || 0}
        initialDate: ${values.initialDate.getTime()}
        finalValidityDate: ${new Date(values.finalValidityDate).getTime()}
        status: "${values.status}"
        obs: ${addDoubleQuotes(values.obs)}
        sumaryContract: ${addDoubleQuotes(values.sumaryContract)}
        discount: ${discount}
        amount: ${amount + discount}
        netValue: ${amount}
        contractType: {
          id: ${values.contractType.id}
          name: "${values.contractType.name}"
          filterByStatus: ${values.contractType.filterByStatus}
          updaterId: ${values.contractType.updaterId}
          active: ${values.contractType.active}
        }
        products: ${JSON.stringify(products).replace(/"([^(")"]+)":/g, '$1:')} 
      }
    ) {
      id
      toGenerate
      status
    }
  }
  `;
  return mutation;
}

export function financialGenerateByContract(id) {
  const query = `{
    financialGenerateByContract(
      contractId: ${id}
    ) {
      id
      products { 
        id
        value
        category {
          id 
          name
          filterByStatus
          updaterId
          active
        }
        discount
        numberInstallments, 
        numberInstallment,
        percentageOfTotal
      }
      description
      category {
        id
        name
        active
        description
      }
      quota
      value
      amountReceived
      discount
      student {
        id
        fullName
        filterByStatus
        updaterId
        active
        legacyId
        dateOfBirth
        activeOnLoggedPeriod
      }
      responsible {
        id
        fullName
        cpf
        zipCode
        address
        addressNumber
        email
        filterByStatus
        updaterId
        validateCpfOnSubmit
        neighborhood
      }
      statusDescription
      obs
      account {
        id
      }
      dueDate
      issuanceDate
      competencyDate
      parcTitu
      nupaTitu
      iuguAction
      type
      status
    }
  }
  `;
  return query;
}

export function financialListByContract(contract) {
  const query = `{
    financialListByContract(contractId: ${contract.id}) {
      id
      description
      products { value, category {id, name}, numberInstallment, numberInstallments, percentageOfTotal }
      category {
        id
        name
      }
      discountConfigurations {
        id
        daysBeforeExpiration
        discountPercentage
      }
      quota
      value
      amountReceived
      discount
      student {
        id
        fullName
      }
      responsible {
        id
        fullName
      }
      statusDescription
      obs
      account {
        id
        name
        smartpay
      }
      dueDate
      issuanceDate
      competencyDate
      parcTitu
      nupaTitu
      iuguAction
      type
      status
    }
  }
  `;
  return query;
}

export function saveFinancialSaveByContract(values) {
  let discountConfigurations = [];
  if (values.applyDiscountConfiguration) {
    discountConfigurations = values.discountConfigurations.map((item) => {
      if (item.tableData) {
        const { tableData, ...itemRef } = item;
        return itemRef;
      }
      return item;
    });
  }
  const { titles } = values;
  const validTitles = titles.filter((title) => title.generate);
  const productList = validTitles.map((title) =>
    title.products.map((prod) => ({
      id: prod.id,
      value: prod.value,
      category: prod.category,
      discount: prod.discount,
      numberInstallment: prod.numberInstallment,
      numberInstallments: prod.numberInstallments,
      quota: '',
      percentageOfTotal: prod.percentageOfTotal,
    }))
  );
  const financial = validTitles.map((title, index) => ({
    id: 0,
    description:
      title.description.replace(
        /\d{1,4}\/\d{1,4}/g,
        `${parseInt(title.quota.split('/')[0], 10)}/${parseInt(
          title.quota.split('/')[1],
          10
        )}`
      ) || '',
    contractId: values.dto.id,
    contract: '',
    category: {
      id: title.category.id,
      name: title.category.name,
      filterByStatus: false,
      updaterId: 0,
      active: title.category.active,
    },
    quota: '',
    value: title.value,
    amountReceived: 0,
    discount: title.discount,
    student: {
      id: title.student.id,
      filterByStatus: title.student.filterByStatus,
      updaterId: title.student.updaterId,
      active: title.student.active,
      legacyId: title.student.legacyId,
      dateOfBirth: 0,
      activeOnLoggedPeriod: title.student.activeOnLoggedPeriod,
    },
    responsible: {
      id: values.dto.responsible1.responsible.id,
      fullName: values.dto.responsible1.responsible.fullName,
      cpf: values.dto.responsible1.responsible.cpf,
      zipCode: values.dto.responsible1.responsible.zipCode,
      address: values.dto.responsible1.responsible.address,
      addressNumber: values.dto.responsible1.responsible.addressNumber,
      neighborhood: values.dto.responsible1.responsible.neighborhood,
      email: values.dto.responsible1.responsible.email,
      filterByStatus: false,
      updaterId: 0,
      validateCpfOnSubmit: false,
      chatUserId: values.dto.responsible1.chatUserId
        ? values.dto.responsible1.chatUserId
        : 0,
    },
    statusDescription: '',
    obs:
      title.description.replace(
        /\d{1,4}\/\d{1,4}/g,
        `${parseInt(title.quota.split('/')[0], 10)}/${parseInt(
          title.quota.split('/')[1],
          10
        )}`
      ) || '',
    account: {
      id: values.account.id,
      filterByStatus: values.account.filterByStatus,
      updaterId: values.account.updaterId,
      checkingAccount: values.account.checkingAccount,
      active: values.account.active,
      defaultAccount: values.account.defaultAccount,
      integrateIfIugu: values.account.integrateIfIugu,
      smartpay: values.account.smartpay,
      numberWithdrawals: values.account.numberWithdrawals,
      extraWithdrawalAmount: values.account.extraWithdrawalAmount,
    },
    dueDate: title.dueDate,
    issuanceDate: 0,
    competencyDate: 0,
    fines: values.fines || false,
    latePaymentFine: values.latePaymentFine || 0,
    perDayInterest: values.perDayInterest || false,
    applyDiscountConfiguration: values.applyDiscountConfiguration || false,
    discountConfigurations: values.applyDiscountConfiguration
      ? discountConfigurations
      : [],
    parcTitu: parseInt(title.quota.split('/')[0], 10),
    nupaTitu: parseInt(title.quota.split('/')[1], 10),
    iuguAction: 'A',
    operation: 'R',
    type: 'R',
    status: 'A',
    automaticBilling: values.automaticBilling || false,
    products: productList[index],
    indRepeat: false,
    paymentFrequency: {
      id: 0,
      monthlyFrequency: 0,
      daylyFrequency: 0,
      active: false,
      order: 0,
    },
    inTestEnvironment: values.inTestEnvironment || false,
    ticketUrl: '',
    updateOption: 'U',
    updateCategory: false,
    updateDescription: false,
    updateObservation: false,
    updateAccount: false,
    updateValue: false,
    updateCompetence: false,
    updateDueDate: false,
    updateDiscount: false,
    updateAutomaticBilling: false,
  }));

  const mutation = `mutation {
        financialSaveByContract(
            financial: ${JSON.stringify(financial).replace(
              /"([^(")"]+)":/g,
              '$1:'
            )}
        ) {
            id
        }
    }
    `;
  return mutation;
}
